import { SecondaryCodeEnum } from "../../generated/Damages";

export interface VideoAnalysisDataResponse {
  pauses: Pause[];
  characterizationCodesWithColors: any;
  segmentationDetails: SegmentationDetailsResponse;
  codesAvailableForDetection: MainCodeWithSecondaryCodes[];
  predictionsPerAccuracy: any;
  detectedTimestamps: number[];
  recommendedConfidenceLevels: { [key: string]: number };
}

export const emptyVideoAnalysisDataResponse: VideoAnalysisDataResponse = {
  pauses: [],
  characterizationCodesWithColors: null,
  segmentationDetails: {
    usedAIVersion: "",
    imageSize: {
      width: 0,
      height: 0,
    },
    defaultAccuracy: 0,
    segmentations: [],
  },
  codesAvailableForDetection: [],
  predictionsPerAccuracy: null,
  detectedTimestamps: [],
  recommendedConfidenceLevels: {},
};

export interface Segmentation {
  groupCode: string;
  timestamp: number;
  accuracy: number;
  coordinates: Coordinate[];
}

export interface GroupedSegmentations {
  groupCode: string;
  segmentations: Segmentation[];
}

export interface TimestampPrediction {
  timestamp: number;
  predictionDetails: PredictionDetails;
}
export interface PredictionDetails {
  mainCode: string;
  c1Code: string;
  c2Code: string;
  accuracy: number;
}

export interface GroupCodesWithMainCodes {
  groupCode: string;
  color: string;
  mainCodesWithSecondaryCodes: MainCodeWithSecondaryCodes[];
}

interface Pause {
  begin: number;
  end: number;
}

export interface SecondaryCode {
  code: SecondaryCodeEnum;
}

export interface ConfidenceLevels {
  [key: string]: number;
}

export interface PredictionGroup {
  mainCode: string;
  hasC1Code: boolean;
  hasC2Code: boolean;
  predictions: Prediction[];
}

export interface DetectionsAtTime {
  [key: string]: {
    mainCode: string;
    C1: boolean;
    C2: string;
  };
}

export interface CodeDetection {
  code: string;
  colorCode: string;
  isVisible?: boolean;
  isDetected?: boolean;
  groupCode?: string;
  secondaryCodes?: SecondaryCode[];
}


interface Prediction {
  secondaryCode: string;
  timestamp: number;
  accuracy: number;
}

interface MainCodeWithSecondaryCodes {
  mainCode: string;
  secondaryCodes: SecondaryCode[];
  color: string;
}

interface Coordinate {
  x: number;
  y: number;
}

interface ImageSize {
  width: number;
  height: number;
}

interface SegmentationDetailsResponse {
  usedAIVersion: string;
  imageSize: ImageSize;
  defaultAccuracy: number;
  segmentations: Segmentation[];
}
